module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074e0_logo_200x200.6228963d.png";